import React from "react"
import {FieldInlineEditableProps} from "../../../render/inline-editable";
import FieldView from "../../../render/view";


export default function FieldReadOnly_InlineEditable(props: FieldInlineEditableProps) {


    return <FieldView field={props.field} model={props.model} />
}
